<script>
import baseMixin from '@/mixins/baseMixin'
import MessageBubbleSkeleton from './message-bubble-skeleton.vue'
export default {
  name: 'MessageContainerSkeleton',
  components: { MessageBubbleSkeleton },
  mixins: [baseMixin],
  data: () => {
    return {
      messages: [
        {
          sent: true,
          type: 'paragraph',
        },
        {
          sent: true,
          type: 'sentences',
        },
        {
          sent: false,
          type: 'paragraph',
        },
        {
          sent: false,
          type: 'sentences',
        },
        {
          sent: true,
          type: 'paragraph',
        },
        {
          sent: true,
          type: 'paragraph',
        },
        {
          sent: true,
          type: 'sentences',
        },
        {
          sent: false,
          type: 'paragraph',
        },
        {
          sent: false,
          type: 'sentences',
        },
        {
          sent: true,
          type: 'paragraph',
        },
        {
          sent: true,
          type: 'paragraph',
        },
        {
          sent: true,
          type: 'sentences',
        },
      ],
    }
  },
  computed: {
    compScrollHeight() {
      const contactBarHeight = this.isMobileViewPort ? 111 : 87
      return {
        // 76px (top nav bar) + 64px (list bar) + 24px debug banner
        height: `calc(100vh - ${
          76 + 64 + (this.isDev ? 24 : 0) + contactBarHeight
        }px)`,
        overflowY: 'auto',
      }
    },
  },
}
</script>

<template>
  <v-card class="fill-height d-flex flex-column" elevation="0">
    <div class="fill-height flex-grow">
      <v-toolbar :dense="isMobileViewPort" flat>
        <v-toolbar-title class="d-flex align-center">
          <v-skeleton-loader type="avatar"></v-skeleton-loader>
        </v-toolbar-title>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text
        id="message-container"
        :style="compScrollHeight"
        class="fill-height flex-grow-1 overflow-y-auto"
      >
        <div class="message-group pa-4">
          <template v-for="(item, ind) in messages">
            <div
              :key="`message-container-skeleton-index-${ind}`"
              :class="{ 'd-flex flex-row-reverse': item.sent }"
            >
              <div>
                <MessageBubbleSkeleton
                  :sent="item.sent"
                  :loader-type="item.type"
                />
              </div>
            </div>
          </template>
        </div>

        <div id="scrolled-content" style="height: 20px" />
      </v-card-text>
    </div>
    <v-divider></v-divider>
    <v-card flat class="flex-shrink">
      <v-card-text class="d-flex align-center">
        <v-textarea
          filled
          :dense="isMobileViewPort"
          auto-grow
          disabled
          hide-details
          placeholder="Type a new message"
          rows="1"
        ></v-textarea>
        <v-btn disabled color="blue" title="send" large icon class="ml-4">
          <v-icon>mdi-send</v-icon>
        </v-btn>
      </v-card-text>
    </v-card>
  </v-card>
</template>
